import React from 'react';

import { Recommendations } from './Recommendations';
import { UserService }     from '../../services/UserService';
import { Game }            from '../../models/Game';
import { User }            from '../../models/User';

type YouMayAlsoLikeGamesProps = {
    games: Game[];
    game: Game;
    user: User;
};

export class YouMayAlsoLikeGames extends React.PureComponent<YouMayAlsoLikeGamesProps> {
    state = {
        games: this.getRelatedGames(),
    };

    getRelatedGames(): Game[] {
        const { game, games, user } = this.props;

        const showMemberGames = UserService.isValidMember(user);

        const related = games.filter(g => {
            // Exclude target game and member-games for non-member users
            if (g.slug === game.slug || !showMemberGames && g.membersOnly) {
                return false;
            }

            const commonTags = (game.categories || []).filter((tag: string) => (
                !!((g.categories || []).find(t => tag === t))
            ));

            return commonTags.length > 0;
        });

        return related.slice(0, 3);
    }

    componentDidUpdate(prevProps) {
        if (this.props.game === prevProps.game && this.props.user === prevProps.user) {
            return;
        }

        this.setState({
            games: this.getRelatedGames(),
        });
    }

    render() {
        if (!this.state.games.length) {return null; }

        return (
            <Recommendations
                title = "You May Also Like"
                description = "you may also like"
                games = {this.state.games}
            />
        );
    }
}
